import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustomModal } from "components";
import { t } from "i18next";
import { StoreListForPickup } from "components/store/StoreList";
import { NotPersistAction } from "store/actions";
import ChangeActionPopup from "components/Modals/ChangeActionPopup";
import useChangePickupStore from "hooks/useChangePickupStore";
import SlideInLayout from "components/layouts/SlideInLayout";

function ChangePickupStoreModal({ actionModal, setActionModal }) {
  const { stores } = useSelector((state) => state?.brand);
  const { pickupStoreModal } = useSelector((state) => state.NotPersist);
  const { handleChangePickupStore } = useChangePickupStore();
  const dispatch = useDispatch();
  return (
    <>
      <SlideInLayout
        open={pickupStoreModal}
        handleClose={() => {
          dispatch(NotPersistAction.togglePickupStoreModal(false));
          dispatch(NotPersistAction.toggleAreaModal(false));
          setActionModal(false);
        }}
        container={{
          className: `py-2`,
        }}
      >
        <StoreListForPickup
          page="checkout"
          stores={stores}
          header={false}
          headerLabel=""
          styleClasses="h-full"
        />
      </SlideInLayout>

      <CustomModal
        open={actionModal}
        setOpen={setActionModal}
        bodyclasses="flex"
        overlayClasses="fixed h-screen w-screen top-0 bg-opacity-20 overflow-hidden transition ease-linear duration-700 z-40"
      >
        <ChangeActionPopup
          title={t(
            "Your existing basket will be cleared if you change your store? Would you like to continue"
          )}
          handleClickYes={() => {
            handleChangePickupStore();
            setActionModal(false);
          }}
          handleClickNo={() => {
            setActionModal(false);
          }}
        />
      </CustomModal>
    </>
  );
}

export default ChangePickupStoreModal;
